/* istanbul ignore file */
import React from 'react';
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { useVacancyGroupId, useVacancyGroupUrl } from '../../../../routing';
import { useFieldHelper } from 'framework/ui/field';

const ViewVacancyPublicationButton = (props: Omit<LinkButtonProps, 'children' | 'url'>) => {
  const groupId = useVacancyGroupId();
  const { getValue: getPublicationId } = useFieldHelper({
    source: 'id',
  });
  const { getPublicationUrl } = useVacancyGroupUrl();

  return (
    <LinkButton {...props} variant="outlined" url={getPublicationUrl(groupId, getPublicationId())}>
      View
    </LinkButton>
  );
};

export default ViewVacancyPublicationButton;
